import { createSelector } from 'reselect';
import { actions } from './actions';

const initialState = {
  pastReviews: null,
  importedReviews: null,
  reviewOrgSettings: null
};

export const getUserPastReviewsSelector = createSelector(
  state => state.profileReducer.pastReviews,
  pastReviews => pastReviews
);

export const getUserImportedReviewsSelector = createSelector(
  state => state.profileReducer.importedReviews,
  importedReviews => importedReviews
);

export const getOrgReviewSettingsSelector = createSelector(
  state => state.profileReducer.reviewOrgSettings,
  reviewOrgSettings => reviewOrgSettings
);

export default (state = initialState, payload = {}) => {
  switch (payload.type) {
    case actions.SAVE_USER_PAST_REVIEWS:
      return {
        ...state,
        pastReviews: payload.reviews
      };
    case actions.SAVE_USER_IMPORTED_REVIEWS:
      return {
        ...state,
        importedReviews: payload.reviews
      };
    case actions.SAVE_REVIEW_MODULE_ORG_SETTINGS:
      return {
        ...state,
        reviewOrgSettings: payload.reviewOrgSettings
      };
    case actions.CLEAR_USER_PAST_REVIEWS:
      return initialState;
    default:
      return state;
  }
};
